import EmptyState from '@app/components/empty-state';
import NoContactsIcon from '@app/components/icons/no-contacts';
import { T } from '@app/components/translation';

export const AddressBookSearchNoResults = () => (
  <EmptyState
    icon={<NoContactsIcon height="25px" />}
    header={
      <T
        _str="No contacts found"
        _comment="Empty state header. Shown in address book search when no contacts are found."
      />
    }
    content={
      <T
        _str="Please adjust your search criteria and try again."
        _comment="Empty state content. Shown in address book search when no contacts are found."
      />
    }
    defaultStyle
  />
);

export default AddressBookSearchNoResults;
